export default "__VITE_ASSET__6a09157d__"